const AVATAR_COLOR_STYLES = [
  'turquoise',
  'green',
  'yellow',
  'orange',
  'red',
  'mauve',
  'purple',
  'bleu',
].map((color) => ({
  backgroundColor: `var(--tag-${color}-background)`,
  color: `var(--tag-${color}-color)`,
}))

export const getColorStyleForLabel = (label: string | null) => {
  if (!label) {
    return {
      backgroundColor: '#f5f5f7',
      color: '#72727D',
    }
  }
  const num = label
    .split('')
    .map((c) => c.charCodeAt(0))
    .join('')

  const modulo = parseInt(num, 10) % Object.keys(AVATAR_COLOR_STYLES).length
  return AVATAR_COLOR_STYLES[modulo]
}

export type AvatarSize =
  | 'xxsmall'
  | 'xsmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'huge'

export const AVATAR_SIZE_MAP: Record<AvatarSize, number> = {
  xxsmall: 18,
  xsmall: 20,
  small: 24,
  medium: 32,
  large: 40,
  huge: 50,
}

/**
 * The outer edge of the agent ring, in the icon's 34-unit viewBox: an ellipse
 * fitted to the glyph's path (within 0.25 units). Lets the badge cut the
 * ring's own oval out of the avatar it sits on.
 */
export const SLITE_AGENT_RING_OUTLINE = {
  viewBox: 34,
  cx: 17.05,
  cy: 17.82,
  rx: 19.36,
  ry: 11.53,
  rotationDeg: -36.1,
}
